module.exports = __webpack_public_path__ + "static/media/WorriedFace.c068c04c.png";